<template>
    <div class="block-info" id="block-info-five">
        <div class="main-wrap">
            <div class="block-info__content">
                <BlockTop />
                <BlockChild />
                <BlockBoy />
                <BlockInformation />
            </div>
        </div>
    </div>
</template>

<script>
import BlockTop from './top'
import BlockChild from './child'
import BlockBoy from './boy'
import BlockInformation from './parents'

export default {
    components: {
        BlockTop,
        BlockChild,
        BlockBoy,
        BlockInformation
    }
}
</script>

<style scoped lang="stylus">
    .block-info {
        padding-bottom 2rem
        padding-top 2rem
        overflow hidden
        +layout-md-and-up() {
            padding-top 3.2rem
        }
    }
</style>

